import { BlocksIconCustomer } from 'blocks-nextjs/blocks-web-components/components/icon/icons/customer';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconCustomer = createComponent({ react: React, tagName: 'cat-icon-customer', elementClass: BlocksIconCustomer });
